import {z} from 'zod'

import {CreateOrUpdateBlockDataSheetDocument} from '@sdox/api'

import {createMetaSchema} from '../../utils/getCreateMetaFromFieldValues'
import {createFormConfig} from '../../utils/createFormConfig'
import {stringToJSONSchema} from '../../utils/jsonSchema'
import {DataSheetForm} from '../../SharedForms/DataSheetForm/DataSheetForm'

import type {CreateOrUpdateBlockDataSheetMutation, BlockDataSheetInput} from '@sdox/api'

type CreateDataSheetValidatorSchema = z.infer<typeof createDataSheetValidatorSchema>

const createDataSheetValidatorSchema = z.object({
  data: z.object({
    rawItems: stringToJSONSchema.pipe(z.array(z.object({}).passthrough())),
    config: stringToJSONSchema.pipe(z.object({}).passthrough()),
    sections: stringToJSONSchema.pipe(z.array(z.object({}).passthrough())),
  }),
  meta: createMetaSchema,
})

export const dataSheetConfig = createFormConfig<
  CreateDataSheetValidatorSchema,
  CreateOrUpdateBlockDataSheetMutation,
  BlockDataSheetInput
>({
  mutationOptions: {
    mutation: CreateOrUpdateBlockDataSheetDocument,
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore FIX WITH REAL INPUT TYPES
  fieldMapper: ({data}) => ({
    rawItems: data.rawItems,
    config: data.config,
    sections: data.sections,
  }),
  validatorSchema: createDataSheetValidatorSchema,
  customFormNode: <DataSheetForm />,
})
